export default __webpack_public_path__ + "static/media/Jingle Bell Rock.9ef40c8d.mp3";